import { ComponentProps } from "react";

type Props = Omit<ComponentProps<"input">, "className">;

export const Checkbox = (props: Props) => {
  return <input type="checkbox" {...props} />;
};
